import { $httpAdminSync } from '@package/shared/api/http';
import { isNullOrUndef } from "../../util/data";
import { $httpAdmin } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";

export interface Nav {
  id: number;
  type: 'home' | 'product' | 'areas' | 'news' | 'custom';
  platefo: number;
  sort: number;
  title: string;
  belong: number;
  content: string;
}

export function apiNavGet(params?: null): AxiosPromise<Omit<Nav, 'content'>[]>;
export function apiNavGet(params: { id: Nav['id']; }): AxiosPromise<Nav>;
export function apiNavGet(params?: { id: Nav['id']; } | null): AxiosPromise<Omit<Nav, 'content'>[] | Nav> {
  if (isNullOrUndef(params?.id)) {
    return $httpAdmin.get('/title/mttitleplatesort');
  }
  return $httpAdmin.post('/title/mttitleplateone', undefined, { params });
}

export async function apiNavAdd(params: Omit<Nav, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mttitleplateadd', params);
  return $httpAdmin.post('/title/mttitleplateadd', params);
}

export async function apiNavUpdate(params: Partial<Nav>): Promise<AxiosPromise> {
  return $httpAdmin.patch('/title/mttitleplateupdate', params);
}

export async function apiNavDelete(id: Nav['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mttitleplatedeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mttitleplatedeletebyid/${id}`);
}
